import { createStore } from 'vuex'

import auth from '@/store/modules/auth'
import global from '@/store/modules/global'

export default createStore({
    modules: {
        auth,
        global,
    },
    strict: process.env.NODE_ENV !== 'production'
})